import React from "react";

const ItemCard = ({ item, type }) => {
	return (
		<a href={item.url} target="_blank" rel="noopener noreferrer">
			<div className="column">
				<div className="card">
					<div>
						{item.synopsis ? (
							<p>{item.synopsis}</p>
						) : (
							<p>No synopsis found.</p>
						)}
					</div>

					<div>
						{item.images.jpg.image_url ? (
							<img
								src={item.images.jpg.image_url}
								alt={item.title}
							/>
						) : (
							<img
								src="https://placehold.jp/275x300.png?text=No+Image+Found."
								alt={item.title}
							/>
						)}
					</div>

					<div>
						{type === "anime" && (
							<span>Episodes: {item.episodes}</span>
						)}
						{type === "manga" && (
							<span>Chapters: {item.chapters}</span>
						)}
						<h3>{item.title}</h3>
					</div>
				</div>
			</div>
		</a>
	);
};

export default ItemCard;
